import { render, staticRenderFns } from "./childCompany.vue?vue&type=template&id=498b0cc4&scoped=true"
import script from "./childCompany.vue?vue&type=script&lang=js"
export * from "./childCompany.vue?vue&type=script&lang=js"
import style0 from "./childCompany.vue?vue&type=style&index=0&id=498b0cc4&prod&lang=scss&scoped=true"
import style1 from "./childCompany.vue?vue&type=style&index=1&id=498b0cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b0cc4",
  null
  
)

export default component.exports